/**
 * The page the scorekeeper opens when the app is entered (Resolve): the last page the user worked on, or a default.
 * Admins, managers and super admins have the Games page and start there; a real media manager has no Games page
 * in the menu and starts on the Livestream. The last page is kept in localStorage of the browser.
 */
export const LAST_ROUTE_KEY = 'media_last_route'

export const REMEMBERED_ROUTES = ['games', 'livestream', 'photos']

export const rememberRoute = (name, storage = window.localStorage) => {
  if (!REMEMBERED_ROUTES.includes(name)) {
    return
  }

  try {
    storage.setItem(LAST_ROUTE_KEY, name)
  } catch (e) {
    // storage blocked (private window): the default start page is used next time
  }
}

const readRememberedRoute = (storage) => {
  try {
    return storage.getItem(LAST_ROUTE_KEY)
  } catch (e) {
    return null
  }
}

/**
 * @param {{ canSeeGames: boolean, isMediaManager: boolean }} access
 * @returns {{ name: string, query: object } | null} null when the user has no start page of this kind (scorekeeper)
 */
export const resolveStartPage = ({ canSeeGames, isMediaManager }, storage = window.localStorage) => {
  if (!canSeeGames && !isMediaManager) {
    return null
  }

  const remembered = readRememberedRoute(storage)
  const allowed = REMEMBERED_ROUTES.filter(name => name !== 'games' || canSeeGames)
  const name = allowed.includes(remembered) ? remembered : (canSeeGames ? 'games' : 'livestream')

  return { name, query: name === 'livestream' ? { tab: 'venues' } : {} }
}

/**
 * Only an external scorekeeper (role SCOREKEEPER) has the "Enter the code" page: there is no list of games for
 * that role. Everybody else (admin, owner, manager = internal scorekeeper, super admin) has the list of games.
 */
export const isExternalScorekeeper = (store) => store.state.currentClient?.role === 'SCOREKEEPER'

/**
 * Where the user goes when a game is over, closed or ejected: the external scorekeeper back to the code page,
 * everybody who has the games goes to Games, the others (media manager) to their own start page.
 */
export const routeAfterGame = (store) => {
  if (isExternalScorekeeper(store)) {
    return { name: 'enterTheGame' }
  }

  return store.getters.isAdminOrInternalScorekeeper ? { name: 'games' } : { name: 'clientResolve' }
}
